// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AuthNetSubmission extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Decimal */
  amount?: number;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(50) */
  entityId?: string;
  /** String(50) */
  entityTableName?: string;
  /** String */
  errorDetail?: string;
  /** Boolean */
  isSandbox!: boolean;
  /** Boolean */
  isSuccess!: boolean;
  /** String(50) */
  maskedCard?: string;
  /** String(255) */
  message?: string;
  /** String(30) */
  operation!: string;
  /** String(50) */
  poNumber?: string;
  /** String(50) */
  refTransactionId?: string;
  /** String(20) */
  responseCode?: string;
  /** String(20) */
  resultCode?: string;
  /** DateTimeOffset */
  submissionTs!: Date;
  /** String(50) */
  transactionId?: string;
}

